import { Button, Col, Form, Modal, Space } from 'antd';
import React, { ReactElement, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormOTPInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import { RootState } from '../../../../../../../store';
import { verificationAadharOtp } from '../../../../../../../store/actions/newAdmissionAction';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import { centeredNotification } from '../../../../../../../utils/utility';
import { setAdhaarLoading, setVerificationModal } from '../../../../../../../store/actions/newAdmissionAction';
import './VerifyIdentityModal.less';

const VerifyIdentityModal = ( {onOTPSuccessSubmit,
   form, referenceId, aadharNumber}: any): ReactElement => {
    const [isLoading, setIsLoading] = useState(false);

  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const dispatch = useDispatch();

  const verifyOtp = (): void => {
    setIsLoading(true);
    if (!form.getFieldsValue()?.otp) { // Restricting API call if OTP field is empty
      centeredNotification('OTP is mandatory for Adhaar');
      setIsLoading(false);
      return;
    }
    const payload = {
      providerId: appdetails.getProviderId(),
      documentType: 'Adhaar',
      docNumber: aadharNumber,
      reference_id: referenceId,
      aadhaar_otp: (form?.getFieldsValue()).otp || null,
    };
    dispatch(verificationAadharOtp(payload, onSuccess, onError));
    form.resetFields(['otp']);
  };

  const onSuccess = (): any => {
    setIsLoading(false);
    onOTPSuccessSubmit();
    dispatch(setAdhaarLoading(false));
    dispatch(setVerificationModal(false));

  };
  const onError = (): any => {
    setIsLoading(false);
    form.setFields([
      {
      name: 'kycAdhaar',
      value: '',
    }]);
    centeredNotification(`Aadhaar verification unsuccessful for new claim creation at  ${appdetails.getProviderName()} . Please share correct OTP and try again.`);
    dispatch(setAdhaarLoading(false));
    dispatch(setVerificationModal(false));
  };

  const close = (): void => {
    dispatch(setAdhaarLoading(false));
    dispatch(setVerificationModal(false));
  };

  return (
    <>
      <Modal visible={true}
        footer={null}
        className={'text-left'}
        centered={true}
        onCancel={close}>
        <Form form={form}>
          <Col>
            <p className="titleText">Please share Aadhaar verification OTP for new claim creation at {appdetails.getProviderName()}.</p>
          </Col>
          <Col>
            <FormOTPInput
              form={form}
              autoFocus={true}
              length={6}
              className="otpContainer centreContainer"
              inputClassName="otpInput" />
          </Col>
          <Space>
            <Button loading={isLoading} className="btn-form-submit centreButton" onClick={verifyOtp}>
              Submit
            </Button>
          </Space>
        </Form>
      </Modal>

    </>
  );

};

export default VerifyIdentityModal;
